function RpcService(options) {
  var rpcService = this;

  rpcService.__restService = new RESTService({
    routePrefix: getRoutePrefix(options),
    baseUrl: options.baseUrl
  });

  function getRoutePrefix(options) {
    return getInterfaceName(options) + '/API';
  }

  function getInterfaceName(options) {
    return options.interfaceName.substr(1);
  }
}

RpcService.prototype.isRpcService = true;

RpcService.prototype.Call = function(method, data, options) {
  var rpcService = this;
  return rpcService.__restService.Create(method, data, null, options);
};
